module.exports = __webpack_public_path__ + "static/img/loading-line-2.6e126fb.png";